export default __webpack_public_path__ + "static/media/logo.fa508b8b.png";